import { observable, computed, action } from 'mobx';

import Step1 from './Step1';
import Summary from './Summary';
import { post } from 'services/request';

export default class Store {
  steps = [
    { key: 'message', title: 'Message to seller', implementation: Step1 },
  ];

  @observable message = '';

  summaryClass = Summary;

  constructor(management) {
    this.sale = management.source;
  }

  @computed get offers() {
    return this.sale.offers.accessibleOffers.map((item) => {
      return {
        item,
        buyerId: item.buyerId,
        name: `${item.buyer.buyer_lastName}, ${item.buyer.buyer_firstName}`,
        submittedValue: item.submittedValue,
        validity: item.data.offer_validity,
        status: item.status,
      };
    });
  }

  handleMessageChange = action((value) => {
    this.message = value;
  });

  @action async submit(saleId, token) {
    await post(
      `/api/v1/wizard/${saleId}/notifyseller`,
      {
        message: this.message,
      },
      token
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/NotifySeller/index.js